module.exports = __webpack_public_path__ + "f1096befec9205b7890fc6d67c3a7132.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/franklin_templeton_investments.png
// module id = 1654
// module chunks = 0